import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Stack } from '@fiverr-private/layout_components';
import { bigQuery } from '@fiverr-private/obs';
import { IconButton } from '@fiverr-private/button';
import { FacebookIcon, TwitterIcon, LinkedinIcon, WhatsappIcon } from '@fiverr-private/visuals';
import { track as mixpanelTrack } from '../../../lib/mixpanel';
import { sendEvent as sendBQEvent } from '../../../lib/bigQuery';
import { SocialLinks } from '../../../lib/interfaces';

const SOCIAL_TYPES = {
  FACEBOOK: 'facebook',
  WHATSAPP: 'whatsapp',
  LINKEDIN: 'linkedin',
  TWITTER: 'twitter',
};

const POPUP_CONFIG = 'height=300, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0';

const Icons = {
  [SOCIAL_TYPES.FACEBOOK]: <FacebookIcon />,
  [SOCIAL_TYPES.TWITTER]: <TwitterIcon />,
  [SOCIAL_TYPES.WHATSAPP]: <WhatsappIcon />,
  [SOCIAL_TYPES.LINKEDIN]: <LinkedinIcon />,
};

interface SocialsProps {
  socialLinks: SocialLinks;
}

export const Socials = ({ socialLinks }: SocialsProps) => {
  const socialAPIs = Object.keys(socialLinks).map((key) => ({
    title: translate(`referral_program_perseus.invitation.share.${key}`),
    link: socialLinks[key],
    key,
  }));

  const onIconClick =
    ({ key, title, link }) =>
    (e) => {
      e.preventDefault();

      const biEvent = {
        type: 'social_share.click',
        group: 'share_on_social_network',
        reason: key,
      };

      bigQuery.send(biEvent);

      /**
       * TODO!!!
       * Need to check
       * Is redundant, have similar event
       * 'Referral Page Inviter - Social Button - Click'
       */
      const mixpanelProps = {
        Media: key,
      };
      mixpanelTrack('Clicked Social Sharing', mixpanelProps);

      mixpanelTrack('Referral Page Inviter - Social Button - Click', { 'Social Type': key });

      const { userId } = getContext();

      sendBQEvent({
        type: 'clicked_on_share_referral_via_social',
        referral_program: {
          referral_inviter: userId,
        },
        page: {
          element: {
            name: key,
            text: title,
            type: 'button',
          },
        },
        action: {
          type: 'click',
        },
      });

      window.open(link, key, POPUP_CONFIG);
    };

  return (
    <Stack as="ul" gap="4">
      {socialAPIs.map((socialAPI) =>
        socialAPI.link ? (
          <Stack as="li" flex="1" justifyContent="center" alignItems="center" key={socialAPI.key}>
            <IconButton
              href={socialAPI.link}
              variant="outline"
              intent="secondary"
              size="md"
              aria-label="share"
              onClick={onIconClick(socialAPI)}
            >
              {Icons[socialAPI.key]}
            </IconButton>
          </Stack>
        ) : null
      )}
    </Stack>
  );
};
